import PropTypes from 'prop-types';
import ArrowButton from '../common/button-arrow';

const MessageFooter = ({
  toggleMessage, toggleReply, onDelete, open, reply, message
}) => (
  <div className="message-footer">
    <div className="float-start delete-message" onClick={() => onDelete(message.id)}>
      <i aria-hidden="true" className="fa fa-trash"/>
    </div>

    <ArrowButton
      submit={false}
      arrow={false}
      color="white"
      className="float-end view-message"
      onClick={toggleMessage}
    >
      {open ? 'close' : 'view'}
    </ArrowButton>

    {reply && (
      <ArrowButton
        submit={false}
        arrow={false}
        color="white"
        className="float-end reply-message"
        onClick={() => toggleReply(true, message)}
      >
        Reply
      </ArrowButton>
    )}

    <div className="clearfix"/>
  </div>
);

MessageFooter.propTypes = {
  toggleMessage: PropTypes.func,
  toggleReply: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool,
  message: PropTypes.object
};


export default MessageFooter;
